/**
 * Download file with the given url.
 *
 * @param {string} url The download url.
 */
const downloadFile = function(url) {
  const hiddenIFrameID = 'downloaderIFrame';
  let iframe = document.getElementById(hiddenIFrameID);
  if (iframe === null) {
    iframe = document.createElement('iframe');
    iframe.id = hiddenIFrameID;
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
  }
  iframe.src = url;
};

export default downloadFile;
